import Intro from '../components/Intro'
import Header2 from "../components/Header2";
import Works from '../components/Works';

function Portfolio () {
    return (
        <div className="bg-darkGray">
            <Header2 />
            <Works />
        </div>
    );
}

export default Portfolio;
